import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import React, { memo, useState } from 'react';
import withUser from '../../../withUser';

const ImportButton = ({ userIsAdmin, menuItems, className }) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);

  return (
    <Dropdown
      menu={{ items: menuItems }}
      disabled={!userIsAdmin}
      onOpenChange={(visible) => setDropdownVisible(visible)}
      className={className}
    >
      <Button
        className="btn-import-model flex items-center justify-center"
        type="primary"
        disabled={!userIsAdmin}
      >
        Importer
        <DownOutlined
          className={`ml-2 transition-transform duration-200 ${
            dropdownVisible ? 'rotate-180' : ''
          }`}
        />
      </Button>
    </Dropdown>
  );
};

export default memo(withUser(ImportButton));
